import { Col, Container, Row } from 'reactstrap'
import { H3, H4, Image } from '../../../../AbstractElements'
import { CartEmpty } from '../../../../utils/Constant'
import { dynamicImage } from '../../../../Service'

const EmptyCart = () => {
  return (
    <section className="cart-section section-b-space">
      <Container fluid>
        <Row>
          <Col sm="12">
            <div>
              <Col sm="12" className="empty-cart-cls text-center">
                <H3>{CartEmpty}</H3>
                <Image src={dynamicImage("logo.png")} alt={"panier vide"} className="img-fluid" />
                <H4>{"Veuillez Ajouter des produits dans le panier"}</H4>
              </Col>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default EmptyCart